// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2JiAR","list":"styles_list__rftkq","disableSelection":"styles_disableSelection__3mnC4"};